export const SUPPORTED_LANGUAGES = [
  { code: 'pl', name: 'Polski', icon: '🇵🇱' },
  { code: 'ru', name: 'Русский', icon: '🇷🇺' },
  { code: 'cs', name: 'Čeština', icon: '🇨🇿' },
  { code: 'de', name: 'Deutsch', icon: '🇩🇪' },
  { code: 'it', name: 'Italiano', icon: '🇮🇹' },
  { code: 'sk', name: 'Slovenčina', icon: '🇸🇰' },
  { code: 'en', name: 'English', icon: '🇬🇧' }, // Fallback/Admin
];

export type LanguageCode = 'pl' | 'ru' | 'cs' | 'de' | 'it' | 'sk' | 'en';
export const DEFAULT_LANGUAGE: LanguageCode = 'pl'; // Default fallback if detection fails
